
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'


export default {
name: 'subimit',
props: [],
components: {
Group, Cell, Flexbox, FlexboxItem, Previewer
},
data () {
return {
addressInfo: this.$store.state.addressInfo,
images: {
data: this.$store.state.addressFile.filesData,
preview: {
type: Boolean,
default: true
}
}

}
},
computed: {},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
onPreview (index) {
if (this.images.preview) {
this.$refs.previewer.show(index)
}
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/address/submit.vue